import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { interiorPreviews } from '../data/assets';
import { resizedImage, resizedSrcSet } from '../utils/image';
export function InsidePreviewSection() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollBy = (direction: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction * el.clientWidth * 0.8,
      behavior: 'smooth'
    });
  };
  return <section className="bg-sand py-12 md:py-20 px-4" data-id="element-124" data-mp="t4ds1q08vyhz">
      <div className="max-w-5xl mx-auto" data-id="element-125" data-mp="f5vyhbnnrrs5">
        <SectionHeading eyebrow="Mira lo que hay dentro" title="No necesitas imaginar lo que recibirás." subtitle="Estas son páginas reales de la Biblioteca Pausa Propia." data-id="element-126" data-mp="f9bcsc9icwsi" />

        <div className="hidden md:flex justify-end gap-2 mb-3" data-id="element-127" data-mp="34w9c4wiu0ypm">
          <button type="button" onClick={() => scrollBy(-1)} aria-label="Ver páginas anteriores" className="w-10 h-10 rounded-full bg-white border border-sand-deep text-forest flex items-center justify-center hover:bg-ivory transition-colors duration-150" data-id="element-128" data-mp="34xkeqt0jk0f5">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-129" data-mp="3cfwi25km21su" />
          </button>
          <button type="button" onClick={() => scrollBy(1)} aria-label="Ver más páginas" className="w-10 h-10 rounded-full bg-white border border-sand-deep text-forest flex items-center justify-center hover:bg-ivory transition-colors duration-150" data-id="element-130" data-mp="37i4l2x53zphs">
            <ChevronRightIcon className="w-5 h-5" data-id="element-131" data-mp="3v7ywrbdoz80g" />
          </button>
        </div>

        <div ref={trackRef} className="no-scrollbar -mx-4 px-4 scroll-px-4 md:mx-0 md:px-0 md:scroll-px-0 flex gap-3 md:gap-5 overflow-x-auto snap-x snap-mandatory pb-2" aria-label="Páginas interiores reales" data-id="element-132" data-mp="3qap0pcvsry3n">
          {interiorPreviews.map(page => <figure key={page.src} className="snap-start shrink-0 w-[72%] sm:w-[46%] md:w-[31%]" data-id="element-133" data-mp="b6oy9g3agbki">
              <div className="aspect-[4/5] rounded-xl overflow-hidden bg-white border border-sand-deep shadow-soft" data-id="element-134" data-mp="g58mjn5ctzg1">
                <img src={resizedImage(page.src, 540)} srcSet={resizedSrcSet(page.src, [360, 540, 720])} sizes="(min-width: 768px) 320px, 72vw" alt={`Página interior: ${page.title}`} className="w-full h-full object-contain" loading="lazy" decoding="async" width={1212} height={1516} data-id="element-135" data-mp="l28sly27f275" />
              </div>
              <figcaption className="mt-2 text-center font-sans text-xs text-forest/65" data-id="element-136" data-mp="18rtdwnltybjl">
                {page.title}
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 text-center font-sans text-[13px] md:text-sm font-medium text-forest/70" data-id="element-137" data-mp="3alk792nz2xe8">
          PDF digital · Imprimible · Guiado · Sin experiencia artística
        </p>

        <div className="mt-5 text-center" data-id="element-138" data-mp="2y9zz49wgpiy7">
          <CTAButton label="QUIERO MI BIBLIOTECA PAUSA PROPIA →" data-id="element-139" data-mp="2y8yog6jcyyh0" />
        </div>
      </div>
    </section>;
}